import type { ReactNode } from 'react'
import './EmptyState.css'

interface EmptyStateAction {
  label: string
  onClick: () => void
  variant?: 'primary' | 'secondary'
}

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: ReactNode
  context?: ReactNode // E.g., "Signed in as..."
  actions?: EmptyStateAction[]
}

export function EmptyState({ icon, title, description, context, actions }: EmptyStateProps) {
  return (
    <div className="empty-state-container">
      {icon && <div className="empty-state-icon">{icon}</div>}
      
      <h2 className="empty-state-title">
        {title}
      </h2>
      
      {description && (
        <div className="empty-state-description">
          {description}
        </div>
      )}

      {context && (
        <div className="empty-state-context">
          {context}
        </div>
      )}

      {actions && actions.length > 0 && (
        <div className="empty-state-actions">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className={action.variant === 'secondary' ? 'empty-state-secondary-btn' : 'empty-state-primary-btn'}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
